/**
 * AutomationStepHeading Component
 *
 * Title and description above the settings of one automation step.
 */
export interface AutomationStepHeadingProps {
  title: string;
  description: string;
}

export function AutomationStepHeading({ title, description }: AutomationStepHeadingProps) {
  return (
    <div>
      <h2 className='text-xl font-bold text-foreground-base'>{title}</h2>
      <p className='text-sm text-foreground-muted mt-xs'>{description}</p>
    </div>
  );
}
